/**
 * 视频自动化处理
 */

import { videoTypes } from '@/config/file-types'

export const mtgVideoSizes = [
  '720x1280',
  '1280x720'
]

export const dspVideoSizes = [
  '300x250',
  '320x480',
  '480x320',
  '320x570',
  '570x320',
  '360x640',
  '640x360',
  '768x1024',
  '1024x768',
  '1080x1080'
]

export const uncategorizedVideoSizes = [
  '960x540',
  '1080x1620',
  '1080x1920',
  '1920x1080'
]

export const fbVideoSizes = [
  '1024x1280', '1280x1024', '1920x1280'
]

export const videoUploadTypes = () => {
  return ['MP4', 'AVI', 'MOV', 'FLV'].map(item => {
    return videoTypes[item.toLowerCase()]
  })
}

export const videoOutputTypes = () => {
  return ['MP4', 'AVI', 'MOV', 'FLV'].map(item => {
    const video = videoTypes[item.toLowerCase()]
    video.filenameExtension = video.filenameExtension.replace('.', '')
    return video
  })
}

/**
 * 检查文件是否查过最大限制，注意单位保持一致
 * @param {number} fileSize
 * @param {number} maxSize
 */
export const isOverLimit = (fileSize, maxSize) => {
  return fileSize > maxSize
}

export const isFileTypeLegal = (fileType, legalFileTypes) => {
  return legalFileTypes.some(item => {
    return item.mediaTypes.some(type => (fileType === type))
  })
}
